import React, { useState, useRef } from "react";
import axios from "../../utils/axios";

import {
  Box,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  //
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  useToast,
  Select,
  Stack,
  Checkbox,
} from "@chakra-ui/react";

import { useDispatch } from "react-redux";

import { getProspects } from "../../redux/actions/prospectActions";

import { AiOutlineDelete } from "react-icons/ai";
import { BiBrain } from "react-icons/bi";

const initialState = {
  file: null,
  subject: "",
  message: "",
  followUpMessage: "",
  scrapping: 0,
  profile_scrapping: 0,
  company_scrapping: 0,
  prompt_status: 0,
};

const BulkProspectModal = ({ isOpen, onOpen, onClose }) => {
  const dispatch = useDispatch();
  const toast = useToast();

  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const fileRef = useRef(null);

  const [state, setState] = useState(initialState);

  const [messages, setMessages] = useState([
    { subject: "", message: "", prompt: "", prompt_status: false },
  ]);

  const {
    file,
    scrapping,
    message,
    followUpMessage,
    profile_scrapping,
    company_scrapping,
    prompt_status,
  } = state;

  const handleImport = async (e) => {
    e.preventDefault();

    try {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("scrapping", parseInt(scrapping));
      formData.append("profile_scrapping", parseInt(profile_scrapping));
      formData.append("company_scrapping", parseInt(company_scrapping));
      formData.append("prompt_status", parseInt(prompt_status));
      //formData.append("subject", subject);
      formData.append("message", message);
      formData.append("followUpMessage", followUpMessage);
      formData.append("messages", JSON.stringify(messages));

      console.log(state);

      const res = await axios.post("/api/emails/bulk-email", formData);
      toast({
        title: res.data.msg,
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "bottom-left",
      });
      dispatch(getProspects());
      onClose(setState(initialState));
    } catch (error) {
      toast({
        title: error.data.msg,
        status: "danger",
        duration: 2000,
        isClosable: true,
        position: "bottom-left",
      });
      console.log(error);
    }
  };

  const messageHandleAddClick = () => {
    setMessages([
      ...messages,
      { subject: "", message: "", prompt: "", prompt_status: false },
    ]);
  };

  const keyHandleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...messages];
    list[index][name] = value;
    setMessages(list);
  };

  const hanldeClickPrompt = (e, index) => {
    const { name, value } = e.target;
    const list = [...messages];
    list[index]["prompt_status"] = !list[index]["prompt_status"];
    // setMessages(list);
    setMessages((prevState) => list);
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    // console.log(checked);
    setState((prevState) => ({ ...prevState, [name]: checked ? 1 : 0 }));
  };

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Import in bulk</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FormControl mb={4}>
            <FormLabel mb={3}>Import file(.xlsx)</FormLabel>
            <label className="bulkBtnDesign" htmlFor="importBulk">
              Upload File
            </label>
            <input
              ref={fileRef}
              type="file"
              name="importBulk"
              id="importBulk"
              style={{ display: "none" }}
              onChange={(e) => {
                setState({ ...state, file: e.target.files[0] });
              }}
            />
          </FormControl>
          <Stack py={5} spacing={5} direction="row">
            <Checkbox
              name="profile_scrapping"
              onChange={(e) => handleCheckbox(e)}
            >
              LinkedIn Profile Scrap
            </Checkbox>
            <Checkbox
              name="company_scrapping"
              onChange={(e) => handleCheckbox(e)}
            >
              LinkedIn Company Scrap
            </Checkbox>
            <Checkbox name="prompt_status" onChange={(e) => handleCheckbox(e)}>
              AI Automation
            </Checkbox>
          </Stack>

          {/* <FormControl mb={4}>
            <FormLabel>Scrap</FormLabel>
            <Select
              placeholder="Select option"
              onChange={(e) => {
                setState({ ...state, scrapping: e.target.value });
              }}
            >
              <option value={0}>No</option>
              <option value={1}>Yes</option>
            </Select>
          </FormControl> */}

          {/* <FormControl>
            <FormLabel>Bulk Subject</FormLabel>
            <Input
              placeholder="Subject"
              value={subject}
              onChange={(e) => setState({ ...state, subject: e.target.value })}
            />
          </FormControl> */}

          {/* <FormControl mt={4}>
            <FormLabel>Bulk Messages:</FormLabel>
            <Textarea
              placeholder="Message"
              resize="none"
              value={message}
              onChange={(e) => setState({ ...state, message: e.target.value })}
            />
          </FormControl> */}

          {messages.length > 0 && (
            <FormControl mt={4}>
              <FormLabel>Bulk Messages:</FormLabel>
              {messages.map((x, i) => {
                return (
                  <Box position="relative" key={i}>
                    <Flex
                      position={"absolute"}
                      top="-5px"
                      right="-5px"
                      zIndex={2}
                    >
                      <Button
                        size="xs"
                        mr={1}
                        colorScheme="orange"
                        onClick={(e) => hanldeClickPrompt(e, i)}
                      >
                        <BiBrain />
                      </Button>
                      <Button size="xs" colorScheme="orange">
                        <AiOutlineDelete />
                      </Button>
                    </Flex>
                    <Box>
                      <Input
                        type="text"
                        placeholder={`Subject ${i + 1}`}
                        mb="2"
                        name="subject"
                        value={x.subject}
                        onChange={(e) => keyHandleInputChange(e, i)}
                      />
                      <Textarea
                        key={i}
                        placeholder={`Write prompt ${i + 1}`}
                        name="prompt"
                        value={x.prompt}
                        resize="none"
                        mb="3"
                        onChange={(e) => keyHandleInputChange(e, i)}
                        display={x.prompt_status ? "block" : "none"}
                      />
                      <Textarea
                        key={i}
                        placeholder={`message ${i + 1}`}
                        name="message"
                        value={x.message}
                        resize="none"
                        mb="3"
                        onChange={(e) => keyHandleInputChange(e, i)}
                      />
                    </Box>
                  </Box>
                );
              })}
            </FormControl>
          )}
          <Button
            colorScheme="orange"
            width={"full"}
            mb="3"
            mt="3"
            cursor={"pointer"}
            onClick={messageHandleAddClick}
          >
            Add Message
          </Button>

          {/* <FormControl mt={4}>
            <FormLabel>Bulk Follow Up Message</FormLabel>
            <Textarea
              placeholder="Follow up message"
              resize="none"
              value={followUpMessage}
              onChange={(e) =>
                setState({ ...state, followUpMessage: e.target.value })
              }
            />
          </FormControl> */}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleImport}>
            Import
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BulkProspectModal;
